import apolloClient from '../../utils/apollo-client';
import { profileSave as mutation } from '../../api/graphql/user';
import { getEnv } from 'ecx.saigon.ui.common';
import Mock from './mock';

export default async function saveUserProfile(profilePayLoad) {
  const env = await getEnv();
  if (env.VUE_APP_USE_MOCK) {
    return Mock.data.profileSave;
  }
  const response = await apolloClient().then((client) =>
    client.mutate({
      mutation,
      variables: { profilePayLoad }
    })
  );
  return response.data.profileSave;
}
